"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = once;
function once(fn) {
    return function () {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/async-eventemitter/~/async/internal/once.js
// module id = 350
// module chunks = 0